(function () {
  /* ── Parse commission data ── */
  var data = { categories: [], inspiration_banners: [] };
  let defaultPreviewImage = null;
  try {
    data = JSON.parse(document.getElementById("cc-data").textContent);
  } catch (e) {
    console.error("Commission data invalid JSON", e);
    return;
  }

  /* ── State ── */
  var state = {
    category: null,
    product: null,
    style: null,
    size: null,
    texture: null,
    colour: null,
    quantity: 1,
    notes: ""
  };

  function findCat() {
    return data.categories.find(function (c) {
      return c.id === state.category;
    });
  }

  function setSumValue(id, text) {
    var el = document.getElementById(id);
    if (!el) return;
    if (text) {
      el.textContent = text;
      el.classList.remove("v-value--placeholder");
    } else {
      el.textContent = "—";
      el.classList.add("v-value--placeholder");
    }
  }

  /* ── Gallery ── */
  var galleryImages = [];
  var galleryIndex = 0;
  var mainDisplay = document.getElementById("cc-main-display");
  var previewImg = document.getElementById("cc-preview-img");
  var galleryNav = document.getElementById("cc-gallery-nav");
  var thumbsHolder = document.getElementById("cc-thumbs");

  function showImage(index) {
    if (!galleryImages.length) return;
    galleryIndex = ((index % galleryImages.length) + galleryImages.length) % galleryImages.length;
    var src = galleryImages[galleryIndex];

    mainDisplay.classList.add("is-transitioning");
    setTimeout(function () {
      previewImg.src = src;
      previewImg.classList.add("is-loaded");
      previewImg.style.display = "block";
      mainDisplay.classList.remove("is-transitioning");
    }, 220);

    thumbsHolder.querySelectorAll(".v-thumb-item").forEach(function (t, i) {
      t.classList.toggle("is-active", i === galleryIndex);
    });
  }

  function setGalleryImages(images) {
    galleryImages = images;
    galleryIndex = 0;
    thumbsHolder.innerHTML = "";

    images.forEach(function (src, i) {
      var t = document.createElement("button");
      t.type = "button";
      t.className = "v-thumb-item" + (i === 0 ? " is-active" : "");
      t.innerHTML = '<img src="' + src + '" alt="">';
      (function (idx) {
        t.addEventListener("click", function () {
          showImage(idx);
        });
      })(i);
      thumbsHolder.appendChild(t);
    });

    if (images.length) {
      /* Show first image immediately without transition on initial set */
      previewImg.src = images[0];
      previewImg.classList.add("is-loaded");
      previewImg.style.display = "block";
    } else {
      previewImg.classList.remove("is-loaded");
      previewImg.removeAttribute("src");
      previewImg.style.display = "none";
    }

    galleryNav.style.display = images.length > 1 ? "" : "none";
  }

  document.getElementById("cc-nav-prev").addEventListener("click", function () {
    showImage(galleryIndex - 1);
  });
  document.getElementById("cc-nav-next").addEventListener("click", function () {
    showImage(galleryIndex + 1);
  });

  /* ── Category tiles ── */
  function renderCategories() {
    var holder = document.getElementById("cc-category-tiles");
    holder.innerHTML = "";
    data.categories.forEach(function (cat) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "v-tile";
      btn.dataset.id = cat.id;
      btn.textContent = cat.name;
      btn.title = cat.name;
      // if (cat.image) btn.style.backgroundImage = "url(" + cat.image + ")";
      btn.addEventListener("click", function () {
        selectCategory(cat.id);
      });
      holder.appendChild(btn);

      // store default preview image
      if (cat.name.toLowerCase() === "other") {
        defaultPreviewImage = cat.preview_image;
      }
    });
  }

  function selectCategory(id) {
    state.category = id;
    state.product = state.style = state.size = state.texture = state.colour = null;
    var cat = findCat();
    if (!cat) return;

    document.querySelectorAll("#cc-category-tiles .v-tile").forEach(function (t) {
      t.classList.toggle("is-active", t.dataset.id === id);
    });

    /* Show category preview image as the only thumbnail */
    var src = cat.preview_image || cat.image;
    setGalleryImages(src ? [src] : []);

    setSumValue("cc-sum-category", cat.name);
    setSumValue("cc-sum-product", "");
    setSumValue("cc-sum-style", "");
    setSumValue("cc-sum-size", "");
    setSumValue("cc-sum-texture", "");
    setSumValue("cc-sum-colour", "");

    renderProducts(cat);

    /* Hide product-level options until a product is picked */
    hideProductOptions();
  }

  function hideProductOptions() {
    ["cc-step-style", "cc-step-size", "cc-step-texture", "cc-step-colour"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = "none";
    });
  }

  function renderProducts(cat) {
    var step = document.getElementById("cc-step-product");
    var holder = document.getElementById("cc-product-tiles");
    holder.innerHTML = "";
    if (!cat.products || !cat.products.length) {
      step.style.display = "none";
      return;
    }
    step.style.display = "";
    cat.products.forEach(function (p) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "v-tile";
      btn.dataset.id = p.id;
      btn.textContent = p.name;
      btn.title = p.name;
      btn.addEventListener("click", function () {
        holder.querySelectorAll(".v-tile").forEach(function (t) {
          t.classList.toggle("is-active", t.dataset.id === p.id);
        });
        selectProduct(p);
      });
      holder.appendChild(btn);
    });
  }

  function selectProduct(prod) {
    state.product = prod.id;
    state.style = state.size = state.texture = state.colour = null;

    setSumValue("cc-sum-product", prod.name);
    setSumValue("cc-sum-style", "");
    setSumValue("cc-sum-size", "");
    setSumValue("cc-sum-texture", "");
    setSumValue("cc-sum-colour", "");

    /* Build gallery: preview image first, then additional thumbnails */
    var images = [];
    var firstSrc = prod.preview_image || defaultPreviewImage;
    if (firstSrc) images.push(firstSrc);
    (prod.thumbnails || []).forEach(function (thumbUrl) {
      if (thumbUrl && thumbUrl !== firstSrc) images.push(thumbUrl);
    });
    setGalleryImages(images);

    /* Render product-level options */
    renderStyles(prod);
    renderSizes(prod);
    renderTextures(prod);
    renderColours(prod);
  }

  function renderStyles(cat) {
    var step = document.getElementById("cc-step-style");
    var holder = document.getElementById("cc-style-tiles");
    holder.innerHTML = "";
    if (!cat.styles || !cat.styles.length) {
      step.style.display = "none";
      return;
    }
    step.style.display = "";
    cat.styles.forEach(function (s) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "v-tile" + (s.image ? " v-tile--has-image" : "");
      b.dataset.id = s.id;
      b.textContent = s.name;
      if (s.image) b.style.backgroundImage = "url(" + s.image + ")";
      b.addEventListener("click", function () {
        state.style = s.id;
        holder.querySelectorAll(".v-tile").forEach(function (t) {
          t.classList.toggle("is-active", t.dataset.id === s.id);
        });
        setSumValue("cc-sum-style", s.name);
      });
      holder.appendChild(b);
    });
  }

  function renderSizes(cat) {
    var step = document.getElementById("cc-step-size");
    var holder = document.getElementById("cc-size-chips");
    holder.innerHTML = "";
    if (!cat.sizes || !cat.sizes.length) {
      step.style.display = "none";
      return;
    }
    step.style.display = "";
    cat.sizes.forEach(function (sz) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "v-chip";
      b.textContent = sz;
      b.dataset.value = sz;
      b.addEventListener("click", function () {
        state.size = sz;
        holder.querySelectorAll(".v-chip").forEach(function (t) {
          t.classList.toggle("is-active", t.dataset.value === sz);
        });
        setSumValue("cc-sum-size", sz);
      });
      holder.appendChild(b);
    });
  }

  function renderTextures(cat) {
    var step = document.getElementById("cc-step-texture");
    var holder = document.getElementById("cc-texture-tiles");
    holder.innerHTML = "";
    if (!cat.textures || !cat.textures.length) {
      step.style.display = "none";
      return;
    }
    step.style.display = "";
    cat.textures.forEach(function (t) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "v-tile" + (t.image ? " v-tile--has-image" : "");
      b.dataset.id = t.id;
      b.textContent = t.name;
      if (t.image) b.style.backgroundImage = "url(" + t.image + ")";
      b.addEventListener("click", function () {
        state.texture = t.id;
        holder.querySelectorAll(".v-tile").forEach(function (x) {
          x.classList.toggle("is-active", x.dataset.id === t.id);
        });
        setSumValue("cc-sum-texture", t.name);
      });
      holder.appendChild(b);
    });
  }

  function renderColours(cat) {
    var step = document.getElementById("cc-step-colour");
    var holder = document.getElementById("cc-colour-swatches");
    holder.innerHTML = "";
    if (!cat.colours || !cat.colours.length) {
      step.style.display = "none";
      return;
    }
    step.style.display = "";
    cat.colours.forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "v-swatch";
      b.style.background = c.hex;
      b.dataset.id = c.id;
      b.title = c.name;
      b.setAttribute("aria-label", c.name);
      b.addEventListener("click", function () {
        state.colour = c.id;
        holder.querySelectorAll(".v-swatch").forEach(function (x) {
          x.classList.toggle("is-active", x.dataset.id === c.id);
        });
        setSumValue("cc-sum-colour", c.name);
      });
      holder.appendChild(b);
    });
  }

  /* ── Qty ── */
  var qtyInput = document.getElementById("cc-qty-input");
  document.getElementById("cc-qty-minus").addEventListener("click", function () {
    if (state.quantity > 1) {
      state.quantity--;
      qtyInput.value = state.quantity;
    }
  });
  document.getElementById("cc-qty-plus").addEventListener("click", function () {
    if (state.quantity < 99) {
      state.quantity++;
      qtyInput.value = state.quantity;
    }
  });
  qtyInput.addEventListener("input", function () {
    var v = parseInt(this.value);
    if (isNaN(v) || v < 1) v = 1;
    if (v > 99) v = 99;
    state.quantity = v;
  });

  /* ── Notes ── */
  document.getElementById("cc-notes").addEventListener("input", function () {
    state.notes = this.value;
  });

  /* ── Submission ── */
  var emailInput = document.getElementById("cc-email-input");
  var inlineErr = document.getElementById("cc-inline-error");
  var submitBtn = document.getElementById("cc-submit");
  var shopifyForm = document.getElementById("cc-shopify-form");

  var validationPassed = false;

  submitBtn.addEventListener("click", function (e) {
    inlineErr.classList.remove("is-visible");
    validationPassed = false;

    /* ── Validate required DOM is present ── */
    var hiddenBody = document.getElementById("cc-hidden-body");
    var hiddenEmail = document.getElementById("cc-hidden-email");
    var hiddenName = document.getElementById("cc-hidden-name");
    if (!hiddenBody || !hiddenEmail || !shopifyForm) {
      e.preventDefault();
      e.stopImmediatePropagation();
      console.error("Commission form: required elements missing", { hiddenBody, hiddenEmail, hiddenName, shopifyForm });
      inlineErr.textContent = "Form is misconfigured. Please refresh the page.";
      inlineErr.classList.add("is-visible");
      return;
    }

    /* ── Validate category ── */
    if (!state.category) {
      e.preventDefault();
      e.stopImmediatePropagation();
      inlineErr.textContent = "Please select a category before submitting.";
      inlineErr.classList.add("is-visible");
      return;
    }

    /* ── Validate email ── */
    var email = emailInput.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      inlineErr.textContent = "Please provide a valid email address so we can reply.";
      inlineErr.classList.add("is-visible");
      emailInput.focus();
      return;
    }

    /* ── All valid: build body and submit ── */
    var cat = findCat();
    var product =
      cat && cat.products ?
        cat.products.find(function (p) {
          return p.id === state.product;
        })
      : null;
    var style =
      cat && cat.styles ?
        cat.styles.find(function (s) {
          return s.id === state.style;
        })
      : null;
    var texture =
      cat && cat.textures ?
        cat.textures.find(function (t) {
          return t.id === state.texture;
        })
      : null;
    var colour =
      cat && cat.colours ?
        cat.colours.find(function (c) {
          return c.id === state.colour;
        })
      : null;

    var body = "--- COMMISSION REQUEST ---\n\n";
    body += "Category: " + (cat ? cat.name : "N/A") + "\n";
    body += "Product: " + (product ? product.name : "N/A") + "\n";
    body += "Style: " + (style ? style.name : "N/A") + "\n";
    body += "Size: " + (state.size || "N/A") + "\n";
    body += "Texture: " + (texture ? texture.name : "N/A") + "\n";
    body += "Colour: " + (colour ? colour.name + " (" + colour.hex + ")" : "N/A") + "\n";
    body += "Quantity: " + state.quantity + "\n\n";
    body += "--- CLIENT NOTES ---\n" + (state.notes || "(no notes provided)") + "\n";

    hiddenBody.value = body;
    hiddenEmail.value = email;
    if (hiddenName) hiddenName.value = "Commission Request — Category: " + (cat ? cat.name : "Custom");

    /* Disable button to prevent double-submit */
    validationPassed = true;
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting…";

    shopifyForm.requestSubmit();
  });

  /* ── Inspiration carousel ── */
  var banners = data.inspiration_banners || [];
  var bannerIdx = 0;
  function renderBanner() {
    if (!banners.length) {
      var b = document.getElementById("cc-info-banner");
      if (b) b.style.display = "none";
      return;
    }
    var bn = banners[bannerIdx];
    var img = document.getElementById("cc-info-img");
    var label = document.getElementById("cc-info-img-label");
    if (bn.image) {
      img.src = bn.image;
      img.style.display = "";
      label.style.display = "none";
    } else {
      img.removeAttribute("src");
      img.style.display = "none";
      label.textContent = bn.image_label || "Image of commission";
      label.style.display = "";
    }
    document.getElementById("cc-info-title").textContent = bn.title || "";
    document.getElementById("cc-info-body").textContent = bn.body || "";
    document.getElementById("cc-info-cta-label").textContent = bn.cta_label || "Explore";
    document.getElementById("cc-info-cta").href = bn.cta_url || "#";
  }
  document.getElementById("cc-info-prev").addEventListener("click", function () {
    if (!banners.length) return;
    bannerIdx = (bannerIdx - 1 + banners.length) % banners.length;
    renderBanner();
  });
  document.getElementById("cc-info-next").addEventListener("click", function () {
    if (!banners.length) return;
    bannerIdx = (bannerIdx + 1) % banners.length;
    renderBanner();
  });

  /* ── Reveal animations ── */
  var reveals = document.querySelectorAll(".v-reveal");
  if (reveals.length) {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    reveals.forEach(function (el) {
      obs.observe(el);
    });
  }

  function initalisehCaptcha() {
    if (window.hcaptcha || document.querySelector('script[src*="hcaptcha"]')) return;
    var s = document.createElement("script");
    s.src = "https://js.hcaptcha.com/1/api.js";
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  /* ── Initial ── */
  renderCategories();
  renderBanner();
  if (data.categories.length > 0) selectCategory(data.categories[0].id);
})();
